module.exports = __webpack_public_path__ + "img/no-shipping-service.7d34b534.svg";